class CountdownTimer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.dataset.deadline || !this.els.timer.exists) return

    this.units = this.getUnits()

    this.interval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  getUnits () {
    const strings = {
      days: this.dataset.daysString,
      hours: this.dataset.hoursString,
      minutes: this.dataset.minutesString,
      seconds: this.dataset.secondsString,
    }

    Object.entries(strings).forEach(([key, value]) => {
      let formattedValue = value.replaceAll('=>', ':')
      formattedValue = JSON.parse(formattedValue)
      strings[key] = formattedValue
    })

    return {
      days: {
        single: strings.days.one,
        plural: strings.days.other,
        show: this.dataset.showDays === 'true',
      },
      hours: {
        single: strings.hours.one,
        plural: strings.hours.other,
        show: this.dataset.showHours === 'true',
      },
      minutes: {
        single: strings.minutes.one,
        plural: strings.minutes.other,
        show: this.dataset.showMinutes === 'true',
      },
      seconds: {
        single: strings.seconds.one,
        plural: strings.seconds.other,
        show: this.dataset.showSeconds === 'true',
      },
    }
  }

  updateCountdown () {
    const now = new Date()
    const diff = this.deadline.getTime() - now.getTime()

    if (diff <= 0) {
      clearInterval(this.interval)
      this.showComplete()
      return
    }

    let remainingSeconds = Math.round(diff / 1000)

    const remaining = {
      days: false,
      hours: false,
      minutes: false,
      seconds: false,
    }

    if (this.units.days.show) {
      remaining.days = Math.floor(remainingSeconds / 86400)
      remainingSeconds -= remaining.days * 86400

      if (remaining.days === 0) {
        remaining.days = false
      }
    }

    if (this.units.hours.show) {
      remaining.hours = Math.floor(remainingSeconds / 3600)
      remainingSeconds -= remaining.hours * 3600

      if (remaining.hours === 0 && remaining.days === false) {
        remaining.hours = false
      }
    }

    if (this.units.minutes.show) {
      remaining.minutes = Math.floor(remainingSeconds / 60)
      remainingSeconds -= remaining.minutes * 60

      if (remaining.minutes === 0 && !this.units.seconds.show) {
        remaining.minutes = 1
      }
    }

    if (this.units.seconds.show) {
      remaining.seconds = remainingSeconds
    }

    this.updateElement(remaining)
  }

  updateElement (remaining) {
    let string = Object.entries(remaining)
      .map(([key, value]) => {
        if (value === false) return false

        const pluralisation = value === 1 ? 'single' : 'plural'
        const string = this.units[key][pluralisation]

        return `<span class="hd-AnnouncementBar_CountdownUnit"><strong>${value}</strong> ${string}</span>`
      })
      .filter(Boolean)
      .join('')

    if (this.titleString) {
      string = `<strong>${this.titleString}</strong> ${string}`
    }

    this.els.timer.element.innerHTML = string
  }

  showComplete () {
    this.els.timer.element.setAttribute('hidden', '')
    this.els.complete.element.removeAttribute('hidden')

    if (this.hideButtons && this.externalEls.buttons?.exists) {
      this.externalEls.buttons.elements.forEach((buttonEl) => {
        buttonEl.setAttribute('hidden', '')
      })
    }
  }

  get deadline () {
    return new Date(this.dataset.deadline)
  }

  get hideButtons () {
    return this.dataset.hideButtons === 'true'
  }

  get titleString () {
    return this.dataset.titleString || ''
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer)
}
